import script from "./body.vue?vue&type=script&lang=ts&setup=true"
export * from "./body.vue?vue&type=script&lang=ts&setup=true"

import "./body.vue?vue&type=style&index=0&id=4f9e09f6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f9e09f6"]])

export default __exports__